module.exports = __webpack_public_path__ + "img/flower.aa347285.png";